@if (alert.length) {
  <div class="notify" [@fade]>
    @for (notification of alert.notifications; track notification) {
<div class="notify__item" [@fade] [ngClass]="{
      'notify__item_success': 1 === notification.type,
      'notify__item_danger': 2 === notification.type
    }"
        (click)="alert.splice(notification)">
        <button class="notify__item-close">
          <i class="icon icon_Small_Close"></i>
        </button>
        <div class="notify__item-header">
          @if (1 === notification.type) {
            <i class="icon icon_Small_Message_Good"></i>
          }
          @if (2 === notification.type) {
            <i class="icon icon_Small_Message_Bad"></i>
          }
          {{notification.subject}}
        </div>
        @if (!notification.link) {
          <div class="notify__item-content">{{notification.body}}</div>
        }
        @if (notification.link) {
          <div class="notify__item-content">
            <a  href="javascript:void(0)" (click)="onLink(notification.link)">{{notification.body}}</a>
          </div>
        }
      </div>
    }
  </div>
}
